import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Maneuvers = class Maneuvers extends VuexModule {
    constructor() {
        super(...arguments);
        this.maneuvers = [];
        this.cachedVersion = 0;
    }
    async fetchManeuvers() {
        const { data: maneuvers, cachedVersion } = await fetchFromCache(this, 'maneuvers', 'maneuvers');
        return { maneuvers, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['maneuvers', 'cachedVersion'] })
], Maneuvers.prototype, "fetchManeuvers", null);
Maneuvers = __decorate([
    Module({ namespaced: true, name: 'maneuvers' })
], Maneuvers);
export default Maneuvers;
